import { render, staticRenderFns } from "./roleAppsList.vue?vue&type=template&id=08c995b2&"
import script from "./roleAppsList.vue?vue&type=script&lang=js&"
export * from "./roleAppsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c995b2')) {
      api.createRecord('08c995b2', component.options)
    } else {
      api.reload('08c995b2', component.options)
    }
    module.hot.accept("./roleAppsList.vue?vue&type=template&id=08c995b2&", function () {
      api.rerender('08c995b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/app/component/roleAppsList.vue"
export default component.exports